<template @click="">
    <v-app id="page" v-if="userAuth">
        <Navbar :displayName="displayName"/>
        <Selector @response="(resp) => response = resp"  class="selector"/>
        <Content v-if="showContent" :dist="selectedDistrict" :year="selectedYear" class="content"/>
    </v-app>
</template>

<script>
import axios from 'axios'
import Navbar from './components/Navbar/Navbar.vue';
import Selector from './components/Selector/Selector.vue';
import Content from './components/Content/Content.vue';

export default {
    /* eslint-disable */
    name: "App",

    // Declare data this instance will use.
    data: () => ({
        // Track if the content should be shown or not.
        showContent: false,
        // Contain the response received from Selector component.
        response: null,
        // Contain selected district and year values emitted from the response.
        selectedDistrict: null,
        selectedYear: null,
        // Track user auth info.
        userAuth: false,
        displayName: null
    }),

    // Subomponents that this component is built from.
    components: { Navbar, Selector, Content },

    // Declare watchers for variables on this instance.
    watch: {
        // Watch the emitted response for changes.
        response(){
            // Set selected district and year attributes.
            this.selectedDistrict = this.response.district;
            this.selectedYear = this.response.year;
            // Check if content should be showed or not.
            this.checkShowContent();
        }
    },

    // Declare methods on the instance.
    methods: {
        checkShowContent(){
            // If the emitted response provided truthy values, show content.
            if(this.selectedDistrict && this.selectedYear){
                this.showContent = true;
            // If the emitted response contained a falsy value, hide content.
            }else{
                this.showContent = false;
            }
        },
    },

    // Runs upon entering the mounted lifecycle hook.
    async mounted() {
        // Make an API call to retrieve the user's auth status.
        const payload = {method: 'check_authentication_status'};
        // Await the result of the API call.
        const api_result = await axios.post(`${this.$baseAPI}common/authentication/`, JSON.stringify(payload), {
            headers: {'Content-Type' : 'application/json'}
        });
        let result = api_result.data.result;
        let url = `${this.$login}${encodeURIComponent(this.$redirect)}`;
        
        // Apply the result of the auth check to userAuth.
        this.userAuth = api_result.data.result.user_logged_in;

        // If the user is not logged in, redirect them to the login portal.
        if(!this.userAuth){
            // Redirect user.
            window.location.href = url;
            return false;
        }else{
            // Set the username.
            this.displayName = result.user_display_name;
        }

        let valid_member = result.member_of.includes('mea.mea_staff') || result.member_of.includes('eweb.Rates Renewals Access');
        if(!valid_member){
            window.location.href = `${this.$baseAPI}portal/index.php`;
            return
        }
    },

    
};
</script>

<style>
html{
    overflow-y: auto;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
}

</style>

